var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("html", [
    _c("head"),
    _vm._v(" "),
    _c(
      "body",
      [
        _c(
          "md-layout",
          { attrs: { "md-gutter": 40 } },
          [
            _c("md-layout"),
            _vm._v(" "),
            _c(
              "md-layout",
              [
                _c("h1", [_vm._v("Authorization in progress...")]),
                _vm._v(" "),
                _c("md-spinner", {
                  attrs: { "md-indeterminate": "", id: "networkSpinner" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("md-layout")
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-84f38fc0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84f38fc0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/google/GoogleCallback.vue
// module id = 607
// module chunks = 0